import AppService from '../shared/App.api';
import { taskFromAPI, taskToAPI } from './Task.model';

const tasksEndpoint = '/admin/tasks';

export default {
  getTasks,
  getSubmissionsForContentRequest,
  getSubmissionMedia,
  getTaskById,
  getReach,
  createTask,
  updateTask,
  endTask,
  deleteTask,
  trackSubmissionsDownloaded,
  reviewSubmission,
};

async function getTasks() {
  const response = await AppService.get(tasksEndpoint);
  return (response.data || []).map(taskFromAPI);
}

async function getSubmissionsForContentRequest(contentRequestId, page) {
  const response = await AppService.get(
    `${tasksEndpoint}/content-requests/${contentRequestId}/submissions?page=${page}`
  );
  return response.data || [];
}

async function getSubmissionMedia(submissionId) {
  const response = await AppService.get(
    `${tasksEndpoint}/submissions/${submissionId}/media`,
    { responseType: 'blob' }
  );
  return response.data;
}

async function getTaskById(taskId) {
  const response = await AppService.get(`${tasksEndpoint}/${taskId}`);
  return taskFromAPI(response.data);
}

// apiTargeting is the API-shaped targeting object (targetingToAPI output).
async function getReach(apiTargeting) {
  const response = await AppService.postJson(
    `${tasksEndpoint}/reach`,
    apiTargeting || {}
  );
  return response.data;
}

async function createTask(task) {
  const response = await AppService.postJson(tasksEndpoint, taskToAPI(task));
  return taskFromAPI(response.data);
}

async function updateTask(taskId, task) {
  const response = await AppService.put(
    `${tasksEndpoint}/${taskId}`,
    taskToAPI(task)
  );
  return taskFromAPI(response.data);
}

async function endTask(taskId) {
  await AppService.put(`${tasksEndpoint}/${taskId}/end`);
}

async function deleteTask(taskId) {
  await AppService.deleteCall(`${tasksEndpoint}/${taskId}`);
}

/**
 * Track the submissions that have been downloaded.
 *
 * @param {Array<string>} submissionIds - The IDs of the submissions
 *  that have been downloaded.
 */
async function trackSubmissionsDownloaded(submissionIds) {
  if (!Array.isArray(submissionIds) || submissionIds.length === 0) {
    return;
  }
  await AppService.put(`${tasksEndpoint}/submissions/downloaded`, {
    submission_ids: submissionIds,
  });
}

/**
 * Save an admin's review of a submission.
 *
 * @param {number} submissionId - The ID of the submission being reviewed.
 * @param {string|null} adminReview - 'LIKED', 'DISLIKED' or null to clear it.
 */
async function reviewSubmission(submissionId, adminReview) {
  await AppService.put(`${tasksEndpoint}/submissions/${submissionId}/review`, {
    admin_review: adminReview,
  });
}
